/*                                                                                                                     
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--'

Copyright (c) 2026 Dynamic IOT Data, Inc. All rights reserved.

@author Andrew Craig
*/
import { BaseService } from './base';

/** Class for handling SMS related services, such as sending commands to devices via SMS.
 *
 */
export class SMSService extends BaseService {
    public async init() {
        return new Promise((resolve, _reject) => {
            console.log('SMS Service Loaded');
            resolve('Loaded');
        });
    }

    /** Set the voltage power of a device to 24V via SMS command.
     *
     * @param deviceId The ID of the device to set the voltage power for.
     * @returns
     */
    public set24VoltagePower(deviceId: string): Promise<string> {
        console.log('Setting 24V power for device: ' + deviceId);
        const url = this.url + '/api/' + this.orgid + '/device/' + deviceId + '/sms/voltage?value=24';
        return fetch(url, {
            method: 'GET',
            headers: this.headers(),
        }).then((response) => {
            return response.json() as Promise<string>;
        });
    }
}
